import { Stack } from "@mui/material";
import React from "react";

export default function HorizontalStack({
  justifyContent = "space-between",
  alignContent = "center",
  children,
  ...rest
}) {
  return (
    <Stack
      direction={"row"}
      justifyContent={justifyContent}
      alignContent={alignContent}
      {...rest}
    >
      {children}
    </Stack>
  );
}
